import React, { Component } from 'react';
import { connect } from 'react-redux';
import { filter } from 'lodash';
import { Button,  Modal } from 'antd';

import {
    submitReportForApproval, approveReport, rejectReport
} from '../actions';
import * as constants from '../constants';
import WorkflowRemarkForm from './WorkflowRemarkForm';

import common from '../../../common';
import currentuser from '../../currentuser';
import uistate from '../../uistate';

import './ReportWorkflowActions.css';

const { currentUserHasRights } = common;
class ReportWorkflowActions extends Component {

    state = {
        addRemarkFormVisible: false,
        wfaction: '',
        idWorkflowInstance: '',
        stepId: '',
    }

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ReportWorkflowActions', key);
    }

    presubmit = async () => {
        if (this.props.selectedDetailReportIsDirty) {
            await this.props.onSave();
            this.submit();
        } else {
            this.submit();
        }
    }
    submit = async () => {
        await this.props.submitReportForApproval();
        this.props.onRedirect();
    }

    pretakeWfAction = async (idWorkflowInstance, stepId, stepTypeActionName) => {
        if (this.props.selectedDetailReportIsDirty) {
            await this.props.onSave();
            this.takeWfAction(idWorkflowInstance, stepId, stepTypeActionName);
        } else {
            this.takeWfAction(idWorkflowInstance, stepId, stepTypeActionName);
        }
    }


    takeWfAction = async (idWorkflowInstance, stepId, stepTypeActionName) => {
        switch (stepTypeActionName.toLowerCase()) {
            case 'reject':
                this.setState({
                    addRemarkFormVisible: true,
                    wfaction: stepTypeActionName.toLowerCase(),
                    idWorkflowInstance,
                    stepId
                });
                break;
            case 'approve':
                await this.props.approveReport(idWorkflowInstance, stepId);
                this.props.onRedirect();
                break;
            default:
                console.log("Unknown wf action !!!")
                break;
        }
    }

    //#region  Form handlers
    handleCancelForm = (e) => {
        this.setState({
            addRemarkFormVisible: false,
            wfaction: '',
            idWorkflowInstance: '',
            stepId: '',
        });
    }
    handleAddRemark = async (values) => {
        switch (this.state.wfaction) {
            case 'reject':
                await this.props.rejectReport(values.remark, this.state.idWorkflowInstance, this.state.stepId);
                this.props.onRedirect();
                break;
            default:
                console.log("Unknown wf action !!!")
                break;
        }
        this.setState({
            addRemarkFormVisible: false,
            wfaction: '',
            idWorkflowInstance: '',
            stepId: '',
        });
    }
    //#endregion

    render() {
        const userupn = this.props.currentuser.upn;
        const useractions = filter(this.props.selectedDetailReport.workflowActions, function (a) {
            return a.upn == userupn || a.redirectedToUPN == userupn
        });
        return (
            <>
                <span className='workflow-actions'>
                    <span className='workflow-actions-label'>{this.label("WorkflowActions")}</span>
                    {this.props.selectedDetailReport.idReportStatus == common.STATUSES.Concept &&
                        (this.props.currentuser.idUser == this.props.selectedDetailReport.idUser) &&
                        <>
                            <Button size='small' ghost type="primary" onClick={() => { this.presubmit() }} >{this.label("Submit")}</Button>
                        </>
                    }
                    {
                        useractions.map(a => <Button key={a.stepTypeActionName} size='small' style={{ margin: 2 }} ghost type="primary" className={a.stepTypeActionName}
                            onClick={() => { this.pretakeWfAction(a.idWorkflowInstance, a.stepId, a.stepTypeActionName) }} >{this.label(a.stepTypeActionName)}</Button>)
                    }
                </span>
                <Modal title={this.label("RemarkForm")} width='50%' destroyOnHidden={true}
                    open={this.state.addRemarkFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <WorkflowRemarkForm labels={this.props.labels} datacontext={{}} onCancel={this.handleCancelForm} onSave={this.handleAddRemark} />
                </Modal>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        selectedDetailReport: state[constants.NAME].selectedDetailReport,
        selectedDetailReportIsDirty: state[constants.NAME].selectedDetailReportIsDirty,
        labels: uistate.selectors.uiLabels(state),
        currentuser: state[currentuser.constants.NAME],
        curLanguage: uistate.selectors.curLanguage(state),
    };
}

export default connect(mapStateToProps,
    {
        submitReportForApproval, approveReport, rejectReport
    })(ReportWorkflowActions);